/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProgressListSettings = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.707 2.707 5 7.414 2.293 4.707l1.414-1.414L5 4.586l3.293-3.293zM8.293 8.793l1.414 1.414L5 14.914l-2.707-2.707 1.414-1.414L5 12.086zm0 7.5 1.414 1.414L5 22.414l-2.707-2.707 1.414-1.414L5 19.586zM22 5H11V3h11zm0 8H11v-2h11zm-4 2v1.053c-.13.044-.255.096-.377.156l-.744-.745-1.415 1.415.745.744c-.06.122-.112.247-.156.377H15v2h1.053c.044.13.096.255.156.377l-.745.744 1.415 1.415.744-.745c.122.06.247.112.377.156V23h2v-1.053c.13-.044.255-.096.377-.156l.744.745 1.415-1.415-.745-.744c.06-.122.112-.247.156-.377H23v-2h-1.053a3.088 3.088 0 0 0-.156-.377l.745-.744-1.415-1.415-.744.745a3.088 3.088 0 0 0-.377-.156V15zm1 5.333a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgProgressListSettings as ProgressListSettings };
